//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events } from "@nuskin/ns-util";
import { UserService, VGDistInfoService } from "@nuskin/ns-account";
import { NsIcon } from "@nuskin/design-components";

import vueEventBus from "./EventBus";

export default {
  name: "NsHeaderProfileToggle",
  components: {
    NsIcon
  },
  props: {
    /**
     * Dropdown open state
     */
    dropdownOpen: Boolean,
    /**
     * Greeting template from translations
     */
    greeting: {
      type: String,
      default: ""
    },
    /**
     * Hides the Signup text
     */
    hideSignUp: Boolean,
    /**
     * Sign in label
     */
    signInLabel: {
      type: String,
      default: ""
    },
    /**
     * Sign up label
     */
    signUpLabel: {
      type: String,
      default: ""
    },
    /**
     * Sign up session key
     */
    signUpSessionKey: {
      type: String,
      default: "preventSignupPrompt"
    }
  },
  data: () => ({
    preferredName: "",
    user: null
  }),
  computed: {
    desktop() {
      return this.$mq === "desktop" || this.$mq === "desktopHD";
    },
    greetingText() {
      const username =
        this.preferredName ||
        this.user.displayName ||
        this.user.localName ||
        this.user.lastName + ", " + this.user.firstName;
      const spaceReplace = this.desktop ? "&nbsp;" : "<br>";
      return this.greeting
        ? this.greeting
            .replace("%username%", username)
            .replace("<br>", spaceReplace)
        : username;
    }
  },
  mounted() {
    this.addListeners();
    this.setUser();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    setUser() {
      const isLoggedIn = UserService.isLoggedIn();
      if (!isLoggedIn) {
        this.user = null;
        return;
      }

      this.user = UserService.getUser();
      this.setUserProfileImageAndName();

      // Fallout Modal for Peru users
      if (
        this.user.accountType != 10 &&
        !sessionStorage[this.signUpSessionKey] &&
        this.user.countryCd == "PE" &&
        document.getElementById("signupPrompt") != null &&
        typeof window.showFalloutPrompt === "undefined" &&
        !this.user.noFalloutMsg
      ) {
        window.showFalloutPrompt = false;
        document.getElementById("signupPrompt").distributorSignupPath =
          "/content/nuskin/es_PE/sign-up/sign-up.html#/distributorsignup-minimal";
        setTimeout(() => {
          events.publish(
            events.account.OPEN_FALLOUT_MODAL,
            this.user.firstName
          );
        }, 1000);
      }
    },

    async setUserProfileImageAndName() {
      if (
        (!this.user.photoURL || !this.user.displayName) &&
        !this.user.isVolumesLoaded
      ) {
        let distInfo = await VGDistInfoService.getVGDistInformation();

        if (distInfo) {
          if (distInfo.photoURL && !this.user.photoURL) {
            this.user = {
              ...this.user,
              photoURL: distInfo.photoURL
            };
          }

          if (distInfo.displayName && !this.user.displayName) {
            this.user = {
              ...this.user,
              displayName: distInfo.displayName
            };
          }
        }
      }
    },

    handlePreferredNameUpdated(preferredName) {
      this.preferredName = preferredName;
    },

    handleProfileImageUpdated(profileImageUrl) {
      this.user = {
        ...this.user,
        photoURL: profileImageUrl
      };
    },

    /**
     * Subscribe to events, should only be called when mounted
     */
    addListeners() {
      // listen to config changes
      vueEventBus.$on("config-changed", this.setUser);

      // LOGIN EVENTS
      events.subscribe(events.authentication.LOGIN_COMPLETE, this.setUser);
      events.subscribe(events.authentication.LOGOUT, this.setUser);

      // USER UPDATES
      events.subscribe(
        events.account.PROFILE_IMAGE_UPDATED,
        this.handleProfileImageUpdated
      );

      events.subscribe(
        events.account.PREFERRED_NAME_UPDATE,
        this.handlePreferredNameUpdated
      );
    },

    /**
     * Unsubscribe from events, should only be called when destroyed
     */
    removeListeners() {
      // stop listening to event bus
      vueEventBus.$off();

      // LOGIN EVENTS
      events.unsubscribe(events.authentication.LOGIN_COMPLETE, this.setUser);
      events.unsubscribe(events.authentication.LOGOUT, this.setUser);

      // USER UPDATES
      events.unsubscribe(
        events.account.PROFILE_IMAGE_UPDATED,
        this.handleProfileImageUpdated
      );

      events.unsubscribe(
        events.account.PREFERRED_NAME_UPDATE,
        this.handlePreferredNameUpdated
      );
    }
  }
};
